import React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  description: string
  icon?: React.ComponentProps<typeof Icon.Large>['icon']
}

const EmptyState = ({ title, description, icon }: React.PropsWithChildren<Props>) => {
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      alignSelf="center"
      gap="s16"
      flexGrow
      maxWidth="s400"
    >
      {icon && <Icon.Large icon={icon} color="grey600" />}
      <Box alignItems="center" gap="s4" textAlign="center">
        <Text.Normal weight="semibold" color="grey1000">
          {title}
        </Text.Normal>
        <Text.Normal size="300" color="grey800">
          {description}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default EmptyState
